"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Upload = exports.RectWithT = exports.Image = exports.Garbage = exports.Emoticon = exports.EditText = exports.CircleFilled = exports.Checkmark = exports.ArrowLeft = void 0;

require("core-js/modules/es.array.fill.js");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["className", "fill"],
    _excluded2 = ["className", "fill"],
    _excluded3 = ["className", "fill"],
    _excluded4 = ["className", "fill"],
    _excluded5 = ["className", "fill"],
    _excluded6 = ["className", "fill"],
    _excluded7 = ["className", "fill"],
    _excluded8 = ["className", "fill"],
    _excluded9 = ["className", "fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArrowLeft = function ArrowLeft(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15147 12L16.5757 2.57573L17.4243 3.42426L8.84853 12L17.4243 20.5757L16.5757 21.4243L7.15147 12Z",
    fill: fill || 'black'
  }));
};

exports.ArrowLeft = ArrowLeft;

var Checkmark = function Checkmark(_ref2) {
  var className = _ref2.className,
      fill = _ref2.fill,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4243 7.42427L9.50001 18.3485L3.57574 12.4243L4.42427 11.5757L9.50001 16.6515L19.5757 6.57574L20.4243 7.42427Z",
    fill: fill || 'black'
  }));
};

exports.Checkmark = Checkmark;

var CircleFilled = function CircleFilled(_ref3) {
  var className = _ref3.className,
      fill = _ref3.fill,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    className: className
  }, props, {
    height: "25",
    width: "25.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "10",
    stroke: fill || '#000000',
    strokeWidth: "3",
    fill: fill || '#000000'
  }));
};

exports.CircleFilled = CircleFilled;

var EditText = function EditText(_ref4) {
  var className = _ref4.className,
      fill = _ref4.fill,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    version: "1.1",
    className: className
  }, props, {
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: '#000000',
    d: "M468.984,49.552h-40v16h40V49.552z M388.984,49.552h-40v16h40V49.552z M308.984,49.552h-40v16h40 V49.552z M228.984,49.552h-40v16h40V49.552z M148.984,49.552h-40v16h40V49.552z M68.984,49.552H49.552v16l0,0v4.56h16v-4.56h3.44 L68.984,49.552L68.984,49.552z M65.544,110.112h-16v40h16V110.112z M65.544,190.112h-16v40h16V190.112z M65.544,270.112h-16v40h16 V270.112z M65.544,350.112h-16v40h16V350.112z M65.544,430.112h-16v38.88h16V430.112z M130.664,452.992h-40v16h40V452.992z M210.664,452.992h-40v16h40V452.992z M290.664,452.992h-40v16h40V452.992z M370.664,452.992h-40v16h40V452.992z M450.664,452.992 h-40v16h40V452.992z M468.976,407.304h-16v40h16V407.304z M468.976,327.304h-16v40h16V327.304z M468.976,247.304h-16v40h16V247.304z M468.976,167.304h-16v40h16V167.304z M468.976,87.304h-16v40h16V87.304z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    y: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "412.904",
    y: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: '#000000',
    d: "M221.6,311.608l-16.28,58.672h-53.6l69.88-228.56h67.816l70.872,228.56h-55.624l-17.6-58.672H221.6z M279.584,272.952l-14.248-48.488c-4.064-13.6-8.128-30.528-11.512-44.096h-0.704c-3.392,13.6-6.784,30.856-10.512,44.096 l-13.6,48.488H279.584z"
  }), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null));
};

exports.EditText = EditText;

var Emoticon = function Emoticon(_ref5) {
  var className = _ref5.className,
      fill = _ref5.fill,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59999C7.36083 3.59999 3.60002 7.3608 3.60002 12C3.60002 16.6392 7.36083 20.4 12 20.4C16.6392 20.4 20.4 16.6392 20.4 12C20.4 7.3608 16.6392 3.59999 12 3.59999ZM2.40002 12C2.40002 6.69806 6.69809 2.39999 12 2.39999C17.302 2.39999 21.6 6.69806 21.6 12C21.6 17.3019 17.302 21.6 12 21.6C6.69809 21.6 2.40002 17.3019 2.40002 12Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52427 13.7082C8.42479 15.3264 10.0979 16.4 12 16.4C13.9021 16.4 15.5752 15.3264 16.4757 13.7082L17.5243 14.2918C16.4287 16.2604 14.3709 17.6 12 17.6C9.62905 17.6 7.57128 16.2604 6.47571 14.2918L7.52427 13.7082Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 10C8.2 10.4418 8.55817 10.8 9 10.8C9.44183 10.8 9.8 10.4418 9.8 10C9.8 9.55817 9.44183 9.2 9 9.2C8.55817 9.2 8.2 9.55817 8.2 10ZM14.2 10C14.2 10.4418 14.5582 10.8 15 10.8C15.4418 10.8 15.8 10.4418 15.8 10C15.8 9.55817 15.4418 9.2 15 9.2C14.5582 9.2 14.2 9.55817 14.2 10ZM9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10C11 11.1046 10.1046 12 9 12ZM15 12C13.8954 12 13 11.1046 13 10C13 8.89543 13.8954 8 15 8C16.1046 8 17 8.89543 17 10C17 11.1046 16.1046 12 15 12Z",
    fill: "black"
  }));
};

exports.Emoticon = Emoticon;

var Garbage = function Garbage(_ref6) {
  var className = _ref6.className,
      fill = _ref6.fill,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 5.8H18.8V5.2H15.2584L14.4795 3.64223C14.344 3.3712 14.0669 3.2 13.7639 3.2H10.2361C9.93305 3.2 9.65604 3.3712 9.52053 3.64223L8.74164 5.2H5.2V5.8ZM20 7H4V5C4 4.44772 4.44772 4 5 4H8L8.44721 3.10557C8.786 2.428 9.47852 2 10.2361 2H13.7639C14.5215 2 15.214 2.428 15.5528 3.10557L16 4H19C19.5523 4 20 4.44772 20 5V7ZM19 8H5V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V8ZM17.8 9.2V20C17.8 20.4418 17.4418 20.8 17 20.8H7C6.55817 20.8 6.2 20.4418 6.2 20V9.2H17.8Z",
    fill: fill || 'black'
  }));
};

exports.Garbage = Garbage;

var Image = function Image(_ref7) {
  var className = _ref7.className,
      fill = _ref7.fill,
      props = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: className
  }, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.4H20C20.8837 2.4 21.6 3.11635 21.6 4V20C21.6 20.8837 20.8837 21.6 20 21.6H4.00002C3.11637 21.6 2.40002 20.8837 2.40002 20V12H3.60002V20C3.60002 20.2209 3.77911 20.4 4.00002 20.4H20C20.2209 20.4 20.4 20.2209 20.4 20V4C20.4 3.77909 20.2209 3.6 20 3.6H12V2.4Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6111 9.02564L14.0069 13.4746L15.5 11.5743L20.2345 17.6H3.75165L10.6111 9.02564ZM6.2484 16.4H17.7655L15.5 13.5166L13.9931 15.4344L10.5889 10.9744L6.2484 16.4Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 5.4V2H6.6V5.4H10V6.6H6.6V10H5.4V6.6H2V5.4H5.4Z",
    fill: fill || 'black'
  }));
};

exports.Image = Image;

var RectWithT = function RectWithT(_ref8) {
  var className = _ref8.className,
      fill = _ref8.fill,
      props = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "32",
    height: "32",
    className: className
  }, props, {
    version: "1.1"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "rgba(0, 0, 0, 0.2)"
  }), /*#__PURE__*/_react.default.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    style: {
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("body", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      background: 'transparent',
      padding: 0,
      marginTop: '-1px',
      fontSize: '18px',
      minHeight: 'unset'
    },
    xmlns: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/_react.default.createElement("div", null, "T")))));
};

exports.RectWithT = RectWithT;

var Upload = function Upload(_ref9) {
  var className = _ref9.className,
      fill = _ref9.fill,
      props = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 17.8C19.8748 17.8 21.8 15.8748 21.8 13.5C21.8 11.1252 19.8748 9.2 17.5 9.2C16.9279 9.2 16.3847 9.31109 15.8887 9.51175C15.2474 9.77115 14.5117 9.48406 14.2187 8.85253C13.2171 6.69339 11.0317 5.2 8.5 5.2C5.02061 5.2 2.2 8.02061 2.2 11.5C2.2 14.8102 4.75294 17.5241 7.9973 17.7802V18.9834C4.08956 18.7248 1 15.4732 1 11.5C1 7.35786 4.35786 4 8.5 4C11.5161 4 14.1164 5.78039 15.3073 8.34756C15.3302 8.397 15.3881 8.41976 15.4387 8.39932C16.0753 8.1418 16.7711 8 17.5 8C20.5376 8 23 10.4624 23 13.5C23 16.5376 20.5376 19 17.5 19H16.0002V17.8H17.5Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 23L11.4 15L12.6 15L12.6 23L11.4 23Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15L15 15L12 12L9 15Z",
    fill: fill || 'black'
  }));
};

exports.Upload = Upload;
//# sourceMappingURL=icons.js.map